export enum NoComparisonsTexts {
    TITLE = "Пока ничего нет",
    DESCRIPTION = "Добавляйте в сравнение интересные объявления и они будут отображаться в этом разделе",
    LINK_TEXT = "К каталогу объявлений"
}